@let localData = data();
<div class="modal-body text-center p-4" [style.color]="localData?.color ?? 'black'">
  <p class="fs-5 mb-0">{{ localData?.message }}</p>
</div>
